module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="next">\n        <span class="custom-radio"></span>\n        Go to next scene\n    </label>\n</div>\n<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="previous">\n        <span class="custom-radio"></span>\n        Go to previous scene\n    </label>\n</div>\n<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="fixed">\n        <span class="custom-radio"></span>\n        Go to scene:\n    </label>\n    <select class="scene-navigation-scene-number form-control"></select>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/sceneNavigation/SceneNavigationActionPropertiesView.tpl
// module id = 1717
// module chunks = 0